import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Form } from '@/components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledSubTitle = styled.div`
  ${pickThemeFontStyles('16', '26', 'SEMI_BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledValueBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HorizontalDivider = styled.div`
  background: ${COLORS.GREY_ALUMINUM};
  height: 1px;
  width: 100%;
`;

export const StyledLabel = styled.div`
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${COLORS.GRAPHITE_GREY};
`;

export const StyledValue = styled.div`
  ${pickThemeFontStyles('16', '20', 'NORMAL')};
  color: ${COLORS.BLACK};
`;

export const StyledForm = styled(Form)`
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1.5rem;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  color: ${COLORS.GREY} !important;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;
